/**
 * CustomerIdentification
 * Provides identity validation based off information submitted for specific customer.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CustomerMock } from './customerMock';


export interface Customer { 
    /**
     * First Name.
     */
    firstName: string;
    /**
     * Last Name.
     */
    lastName: string;
    /**
     * Full SSN (9).
     */
    ssn: string;
    /**
     * Street address.
     */
    address: string;
    /**
     * City.
     */
    city?: string;
    /**
     * 5-digit ZIP code (5).
     */
    zip?: string;
    /**
     * State (2).
     */
    state?: string;
    /**
     * Day of Birth (2).
     */
    dobDay?: string;
    /**
     * Month of Birth (2).
     */
    dobMonth?: string;
    /**
     * Year of Birth (4).
     */
    dobYear?: string;
    /**
     * Email address.
     */
    email?: string;
    /**
     * Phone number (10).
     */
    phone?: string;
    mock?: CustomerMock;
}

